import { makeStyles } from '@material-ui/core/styles'

export const searchFieldStyle = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(1),
    width: '100%'
  },
  loading: {
    position: 'absolute',
    right: theme.spacing(7),
    color: theme.palette.primary.main
  },
  textField: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(1),
    fontSize: '1rem',
    height: 35,
    borderRadius: '0.3rem'
  }
}))
